import { TranscribeLibraryVideoMeta, TranscribeLibraryVideoPayload } from 'types/store/TranscribeLibraryVideo';
import { createAsyncReducer } from 'utils/Redux';

import { transcribeLibraryVideoActions } from '../actions';

export default createAsyncReducer<TranscribeLibraryVideoMeta, TranscribeLibraryVideoPayload>(transcribeLibraryVideoActions);
